import React from 'react'
import { fontFamily } from '../../styles/theme'

// Deterministic pastel color from string
function avatarColor(name: string): string {
  const palette = [
    '#5B3F9A', '#1A6B4A', '#0C1F3A', '#8B3A3A', '#2D5A8B',
    '#6B4A2D', '#1A4A6B', '#4A6B1A', '#6B1A4A', '#2D6B5A',
  ]
  let h = 0
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0
  return palette[h % palette.length]
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/)
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
  return name.slice(0, 2).toUpperCase()
}

interface AvatarProps {
  name: string
  size?: number
  style?: React.CSSProperties
}

export function Avatar({ name, size = 28, style }: AvatarProps) {
  const bg = avatarColor(name)
  const fs = Math.max(9, Math.round(size * 0.36))
  return (
    <div style={{
      width: size,
      height: size,
      borderRadius: '50%',
      background: bg,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      ...style,
    }}>
      <span style={{
        color: '#fff',
        fontSize: fs,
        fontWeight: 600,
        fontFamily: fontFamily.sans,
        lineHeight: 1,
        letterSpacing: '0.01em',
      }}>
        {initials(name)}
      </span>
    </div>
  )
}
